import Section from 'components/Section';
import React from 'react';
import { Link } from 'react-router-dom';
import { User, UserStatusEnum } from 'types';
import { getEnumKeyFromValue } from 'utils/common';
import DataGridTable from '.';

const AllEmployees: React.FC<{ title: string; rows: User[] }> = ({ title, rows }) => {
  return (
    <Section title={title} collapsible>
      <DataGridTable
        sx={{
          maxWidth: '78vw',
          mx: 'auto',
          minHeight: '10vh',
          maxHeight: '75vh',
        }}
        getRowId={row => row._id}
        columns={[
          {
            field: 'empId',
            headerName: 'Emp ID',
            minWidth: 100,
            renderCell: params => (
              <Link to={`/team/${params.row._id}?name=${params.row.name}`}>{params.row.empId}</Link>
            ),
          },
          { field: 'name', headerName: 'Name', minWidth: 100, flex: 1 },
          { field: 'designation', headerName: 'Designation', minWidth: 150 },
          { field: 'email', headerName: 'Email', minWidth: 150, flex: 1 },
          {
            field: 'userInfo1',
            headerName: 'Objective Settings Status',
            minWidth: 220,
            valueFormatter: (_, row: User) =>
              getEnumKeyFromValue(UserStatusEnum, row.annualUserInfo?.startYearStatus),
          },
          {
            field: 'annualUserInfo2',
            headerName: 'Mid Year Status',
            minWidth: 200,
            valueFormatter: (_, row: User) =>
              getEnumKeyFromValue(UserStatusEnum, row.annualUserInfo?.midYearStatus),
          },
          {
            field: 'annualUserInfo3',
            headerName: 'End Year Status',
            minWidth: 200,
            valueFormatter: (_, row: User) =>
              getEnumKeyFromValue(UserStatusEnum, row.annualUserInfo?.endYearStatus),
          },
        ]}
        rows={rows}
      />
    </Section>
  );
};

export default AllEmployees;
